<div class="email-header-attachments">
  <span class="email-attachment" *ngFor="let attachment of attachments" title='{{ attachment.fileName }}'>
    <i class="email-attachment-icon fa {{ attachment.iconClass }}" [attr.data-automation-id]="'bc-email-attachment-icon'"></i>
    <a class="email-attachment-label"
       target="_blank"
       [href]="attachment.downloadUrl"
       [attr.data-automation-id]="'bc-email-attachment-label'">
      {{ attachment.shortFileName }}
    </a>
    <a class="email-attachment-control"
       [hidden]="!attachment.canDelete"
       (click)="delete(attachment)"
       [attr.data-automation-id]="'bc-email-attachment-control'">
      <i class="icon fa fa-times-circle"></i>
    </a>
  </span>
</div>
